module.exports = __webpack_public_path__ + "static/img/video360-ok1.0dc4dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/videodaily/video360-ok1.jpg
// module id = 8QPc
// module chunks = 1